/**
 * Generate a valid UUID for use as database ID
 * Uses crypto.randomUUID() for proper UUID v4 format
 * This ensures compatibility with Postgres uuid columns
 */
export const generateId = (): string => {
  // Use built-in crypto.randomUUID() for proper UUID format
  // Falls back to legacy format only if crypto is unavailable (old browsers)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Fallback for old browsers (should never happen in modern apps)
  // This generates a UUID v4 format manually
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};
